
export const AIR_TITLE = 'Complete your Annual Check-In';
export const AIR_SUBTITLE = 'A lot can change in a year, and as your life evolves, so does our financial advice. Please take 5 minutes to complete your Annual Check-In so we can ensure you thrive in the year ahead.\n';
